// Components
import { useCallback, useEffect } from 'react';
import DiscardConfirmation, {
  useDiscardConfirmation,
} from 'components/DiscardConfirmation';
// Utils
import { getText } from 'i18n/intl';
// Slices
import {
  checkAvailabilityRelationSaveDisabled,
  fetchAvailabilityRelations,
} from 'slices/availabilityRelation.slice';
import { requestObjectTypes } from 'slices/objectTypes.slice';
import { useAppDispatch } from 'slices/store';
import { DefaultContentLayout } from '@timeedit/ui-components';
import AvailabilityRelationDrawer from './AvailabilityRelationDrawer';
import AvailabilityRelationList from './AvailabilityRelationList';

const AvailabilityRelationPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchAvailabilityRelations());
    dispatch(requestObjectTypes());
  }, []);

  const [
    openDiscardDialog,
    onCloseDiscardDialog,
    confirmFn,
    confirmDiscardChanged,
  ] = useDiscardConfirmation();

  const confirmDiscardPaddingChanges = useCallback(
    (isFirstDrawer: boolean, actionFn: () => void) => {
      const isFieldRelationDisabled = dispatch(
        checkAvailabilityRelationSaveDisabled(isFirstDrawer)
      );
      if (!isFieldRelationDisabled) {
        return confirmDiscardChanged(actionFn);
      }
      actionFn();
    },
    []
  );

  return (
    <DefaultContentLayout
      title={getText('availability_relations_title')}
      subtitle={getText('availability_relations_subtitle')}
    >
      <div className="inner-content--wrapper">
        <AvailabilityRelationList
          confirmDiscardPaddingChanges={confirmDiscardPaddingChanges}
        />
        <AvailabilityRelationDrawer
          confirmDiscardPaddingChanges={confirmDiscardPaddingChanges}
        />
      </div>
      <DiscardConfirmation
        open={openDiscardDialog}
        onClose={onCloseDiscardDialog}
        confirmFn={confirmFn}
      />
    </DefaultContentLayout>
  );
};

export default AvailabilityRelationPage;
